<mg-table [collectionComponent]="this" matSort [selectable]="false">

	<ng-container matColumnDef="date">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Date </th>
        <td mat-cell *matCellDef="let row"> {{row.date | date:'medium'}} </td>
    </ng-container>

	<ng-container matColumnDef="ipAddress">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Ip Address </th>
        <td mat-cell *matCellDef="let row"> {{row.ipAddress}} </td>
    </ng-container>

</mg-table>
